import momentjs from 'moment-jalaali';
import * as moment from 'moment-hijri';
import { returnWeekDays } from '../consts/months';
import { fileHandlerUrl } from '../consts/server';
const shamsiMonthList = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];
const specialNumber = {
  ltr: [
    'Zeroth',
    'First',
    'Second',
    'Third',
    'Fourth',
    'Fifth',
    'Sixth',
    'Seventh',
    'Eighth',
    'Ninth',
  ],
  rtl: [
    'صفرم',
    'اول',
    'دوم',
    'سوم',
    'چهارم',
    'پنجم',
    'ششم',
    'هفتم',
    'هشتم',
    'نهم',
  ],
};
const flightPage = [
  { path: 'select-city', route: 'selectCity' },
  { path: 'selcet-flight-date', route: 'selectFlightDate' },
  { path: 'select-flight', route: 'selectFlight' },
  { path: 'select-login-type', route: 'selectLoginType' },
  { path: 'identify', route: 'identify' },
  { path: 'flight-Invoice', route: 'flightInvoice' },
];
export const stringifyNumber = (number, direction) => {
  return specialNumber[direction][number];
};

const monthNames = {
  ltr: {
    en: 'January February March April May June July August September October November December'.split(
      ' ',
    ),
    ru: 'Январь февраль март апрель май июнь июль август сентябрь октябрь ноябрь декабрь'.split(
      ' ',
    ),
    de: 'Januar Februar März April Mai Juni Juli August September Oktober Oktober November Dezember'.split(
      ' ',
    ),
    it: 'Gennaio Febbraio Marzo Aprile Maggio Giugno Luglio Agosto Settembre Ottobre Novembre Dicembre'.split(
      ' ',
    ),
    fa: 'ژانویه فوریه مارس آپریل می ژوئن جولای آگوست سپتامبر اکتبر نوامبر دسامبر'.split(
      ' ',
    ),
    ja: '1月 2月 3月 4月 5月 6月 7月 8月 9月 10月 11月 12月'.split(' '),
    ar: 'محرم صفر ر-اول ر-ثانی ج-اول ج-ثانی رجب شعبان رمضان شوال ذیقعده ذیحجه'.split(
      ' ',
    ),
  },
  rtl: {
    fa: 'فروردین اردیبهشت خرداد تیر مرداد شهریور مهر آبان آذر دی بهمن اسفند'.split(
      ' ',
    ),
    en: 'Farvardin Ordibehesht Khordad Tir Mordad Shahrivar Mehr Aban Azar Day Bahman Esfand'.split(
      ' ',
    ),
    ru: 'Farvardin Ordibehesht Khordad Tir Mordad Shahrivar Mehr Aban Azar Day Bahman Esfand'.split(
      ' ',
    ),
    it: 'Farvardin Ordibehesht Khordad Tir Mordad Shahrivar Mehr Aban Azar Day Bahman Esfand'.split(
      ' ',
    ),
    de: 'Farvardin Ordibehesht Khordad Tir Mordad Shahrivar Mehr Aban Azar Day Bahman Esfand'.split(
      ' ',
    ),
    ja: 'Farvardin Ordibehesht Khordad Tir Mordad Shahrivar Mehr Aban Azar Day Bahman Esfand'.split(
      ' ',
    ),
    ar: "Muharram Safar Rabi' al-Awwal Rabi' al-Thani Jumada al-Ula Jumada al-Alkhirah Rajab Sha’ban Ramadhan Shawwal Thul-Qi’dah Thul-Hijjah".split(
      ' ',
    ),
  },
};
const DATE_FORMAT_MOMENT_SHAMSI = 'YYYY-M-D';
const DATE_FORMAT_MOMENT_SHAMSI_JALALI = 'jYYYY-jMM-jDD';
export const passengersCount = (parsedQueryStr) => {
  return (
    parseInt(parsedQueryStr?.ad || 0) +
    parseInt(parsedQueryStr?.ch || 0) +
    parseInt(parsedQueryStr?.in || 0) +
    parseInt(parsedQueryStr?.se || 0) +
    parseInt(parsedQueryStr?.td || 0)
    //  +    (parseInt(parsedQueryStr.st) || 0)
  );
};
export const passengerType = (parsedQueryStr) => {
  let totalPassenger = passengersCount(parsedQueryStr);
  if (parsedQueryStr.ad === totalPassenger) return 'Adult';
  else if (parsedQueryStr.ch === totalPassenger) return 'child';
  else if (parsedQueryStr.se === totalPassenger) return 'senior';
  else if (parsedQueryStr.st === totalPassenger) return 'student';
  else if (parsedQueryStr.td === totalPassenger) return 'toddler';
  else return 'guest';
};
export const returnPassengerTypeCount = (passengerType, parsedQueryStr) => {
  switch (passengerType.toLowerCase()) {
    case 'adult':
      return parseInt(parsedQueryStr.ad);
    case 'child':
      return parseInt(parsedQueryStr.ch);
    case 'infant':
      return parseInt(parsedQueryStr.in);
    case 'senior':
      return parseInt(parsedQueryStr.se);
    // case "student":
    //   return parseInt(parsedQueryStr.st);
    case 'toddler':
      return parseInt(parsedQueryStr.td);
    default:
      return 0;
  }
};
export const returnPassengerTypeCountByFlight = (passengerType, flights) => {
  switch (passengerType.toLowerCase()) {
    case 'adult':
      return parseInt(flights?.adultCount);
    case 'child':
      return parseInt(flights?.childCount);
    case 'infant':
      return parseInt(flights?.infantCount);
    default:
      return 0;
  }
};
export const returnAllPassengerTitle = (parsedQueryStr, intl) => {
  let adult = parsedQueryStr.ad,
    child = parsedQueryStr.ch,
    infant = parsedQueryStr.in,
    senior = parsedQueryStr.se,
    toddler = parsedQueryStr.td;
  // student = parsedQueryStr.st;
  let adultTitle =
      adult > 0
        ? `${adult} ${intl.formatMessage({
            id: 'booking.adult',
          })}`
        : '',
    childTitle =
      child > 0
        ? `${adult > 0 ? ' , ' : ' '} ${child} ${intl.formatMessage({
            id: 'booking.child',
          })}`
        : '',
    infantTitle =
      infant > 0
        ? ` , ${infant} ${intl.formatMessage({
            id: 'booking.infant',
          })}`
        : '',
    seniorTitle =
      senior > 0
        ? ` , ${senior} ${intl.formatMessage({
            id: 'booking.senior',
          })}`
        : '',
    // studentTitle =
    //   student > 0
    //     ? ` , ${student} ${intl.formatMessage({
    //         id: "booking.students",
    //       })}`
    //     : "",
    toddlerTitle =
      toddler > 0
        ? ` , ${toddler} ${intl.formatMessage({
            id: 'booking.toddler',
          })}`
        : '';
  // ${studentTitle}
  return `${adultTitle}${childTitle}${infantTitle}${seniorTitle}${toddlerTitle}`;
};
export const returnValidPassengerType = (
  adultCount,
  childCount,
  infantCount,
  passengerType,
  selectedPassengerType,
) => {
  const passengerInfo = JSON.parse(sessionStorage.getItem('passengers'));
  let ISVALID = false;
  const selectedAdultCount = passengerInfo
      ? passengerInfo.filter((item) => item.type === 'adult').length
      : 0,
    selectedChildCount = passengerInfo
      ? passengerInfo.filter((item) => item.type === 'child').length
      : 0,
    selectedAInfantCount = passengerInfo
      ? passengerInfo.filter((item) => item.type === 'infant').length
      : 0;

  if ((passengerInfo && passengerInfo.length === 0) || !passengerInfo) {
    return selectedPassengerType === passengerType ? true : false;
  } else {
    switch (selectedPassengerType) {
      case 'adult':
        ISVALID = selectedAdultCount < adultCount ? true : false;
        break;
      case 'child':
        ISVALID = selectedChildCount < childCount ? true : false;
        break;
      case 'infant':
        ISVALID = selectedAInfantCount < infantCount ? true : false;
        break;
      case 'unknown':
        ISVALID = true;
      default:
        ISVALID = false;
        break;
    }
    return ISVALID;
  }
};
export const returnCurrentPassengerType = (
  adultCount,
  childCount,
  infantCount,
  seniorCount,
  toddlerCount,
) => {
  const passengerInfo = JSON.parse(sessionStorage.getItem('passengers'));
  if ((passengerInfo && passengerInfo.length === 0) || !passengerInfo) {
    return 'adult';
  } else {
    if (parseInt(seniorCount) > 0) {
      let seniors = passengerInfo.filter((item) => {
        return item.type === 'senior';
      });
      if (seniors.length < parseInt(seniorCount)) return 'senior';
    }
    if (parseInt(adultCount) > 0) {
      let adults = passengerInfo.filter((item) => {
        return item.type === 'adult';
      });
      if (adults.length < parseInt(adultCount)) return 'adult';
    }
    if (parseInt(childCount) > 0) {
      let children = passengerInfo.filter((item) => {
        return item.type === 'child';
      });
      if (children.length < parseInt(childCount)) return 'child';
    }
    if (parseInt(infantCount) > 0) {
      let infants = passengerInfo.filter((item) => {
        return item.type === 'infant';
      });
      if (infants.length < parseInt(infantCount)) return 'infant';
    }
    if (parseInt(toddlerCount) > 0) {
      let toddlers = passengerInfo.filter((item) => {
        return item.type === 'toddler';
      });
      if (toddlers.length < parseInt(toddlerCount)) return 'toddler';
    }
  }
};
const today = new Date().toISOString().split('T')[0],
  shamsiCurrentYear = parseInt(
    momentjs(today, DATE_FORMAT_MOMENT_SHAMSI).format('jYYYY'),
  ),
  currentYear = parseInt(today.split('-')[0]);

export const fillBirthYear = (direction) => {
  let yearLst = [],
    tempCurrentYear = direction === 'rtl' ? shamsiCurrentYear : currentYear;
  for (let year = tempCurrentYear - 100; year <= tempCurrentYear; year++)
    yearLst.push({
      index: year,
      Name: year,
    });
  return yearLst;
};
export const fillPassportExpireYear = (direction) => {
  let expireYearLst = [],
    tempCurrentYear = direction === 'rtl' ? shamsiCurrentYear : currentYear;
  for (let year = tempCurrentYear; year <= tempCurrentYear + 15; year++) {
    expireYearLst.push({
      index: year,
      Name: year,
    });
  }
  return expireYearLst;
};
export const checkMonthEnd = (ind) => {
  let date = new Date().addDays(ind);
  if (
    this.props.language.direction === 'ltr' &&
    date.getMonth() !== date.addDays(1).getMonth()
  )
    return true;
  else if (
    this.props.language.direction === 'rtl' &&
    momentjs(
      date.toISOString().split('T')[0],
      DATE_FORMAT_MOMENT_SHAMSI,
    ).format('jMM') !==
      momentjs(
        date.addDays(1).toISOString().split('T')[0],
        DATE_FORMAT_MOMENT_SHAMSI,
      ).format('jMM')
  )
    return true;
  else return false;
};
export const setSkippDayes = (skipDays) => {
  if (this.props.language.direction === 'rtl') skipDays += 1;
  return new Array(skipDays).fill(undefined);
};
export const setMonth = (date) => {
  if (this.props.language.direction === 'ltr') return date.getMonth() + 1;
  else
    return parseInt(
      momentjs(
        date.toISOString().split('T')[0],
        DATE_FORMAT_MOMENT_SHAMSI,
      ).format('jMM'),
    );
};
export const returnCabinClassList = () => {
  return [
    { name: 'Economy', image: 'cabin-economy' },
    { name: 'Business', image: 'cabin-business' },
    { name: 'First', image: 'cabin-first' },
  ];
};
export const setYear = (date) => {
  if (this.props.language.direction === 'ltr') return date.getFullYear();
  else
    return parseInt(
      momentjs(
        date.toISOString().split('T')[0],
        DATE_FORMAT_MOMENT_SHAMSI,
      ).format('jYYYY'),
    );
};
export const hasFilter = (selectedFilter) => {
  return (
    (selectedFilter.stopCountSelected.length > 0 &&
      selectedFilter.stopCountSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.flightNumberSelected.length > 0 &&
      selectedFilter.flightNumberSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.airportSelected.length > 0 &&
      selectedFilter.airportSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.arrivalAirportSelected.length > 0 &&
      selectedFilter.arrivalAirportSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.airlineSelected.length > 0 &&
      selectedFilter.airlineSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.layoverAirportSelected.length > 0 &&
      selectedFilter.layoverAirportSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.baggageSelected.length > 0 &&
      selectedFilter.baggageSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.charterSelected.length > 0 &&
      selectedFilter.charterSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.cabinSelected.length > 0 &&
      selectedFilter.cabinSelected.some((x) => Object.entries(x).length > 0)) ||
    (selectedFilter.priceRangeSelected &&
      Object.keys(selectedFilter.priceRangeSelected).length) ||
    (selectedFilter.timeSelected &&
      selectedFilter.timeSelected.some((x) => Object.entries(x).length > 0)) ||
    (selectedFilter.durationSelected &&
      selectedFilter.durationSelected.some(
        (x) => Object.entries(x).length > 0,
      )) ||
    (selectedFilter.providerSelected &&
      selectedFilter.providerSelected.some((x) => Object.entries(x).length > 0))
  );
};
export const fillYearByPassengerType = (direction, type) => {
  let yearLst = [],
    tempCurrentYear = direction === 'rtl' ? shamsiCurrentYear : currentYear;
  let minYear, maxYear;
  switch (type) {
    case 'senior':
      minYear = tempCurrentYear - 163;
      maxYear = tempCurrentYear - 60;
      break;
    case 'adult':
      minYear = tempCurrentYear - 163;
      maxYear = tempCurrentYear - 12;
      break;
    case 'child':
      minYear = tempCurrentYear - 12;
      maxYear = tempCurrentYear - 2;
      break;
    case 'infant':
    case 'toddler':
      minYear = tempCurrentYear - 2;
      maxYear = tempCurrentYear;
      break;
    default:
      minYear = tempCurrentYear - 163;
      maxYear = tempCurrentYear - 12;
      break;
  }

  for (let year = maxYear; year >= minYear; year--)
    yearLst.push({
      index: year,
      Name: year,
    });

  return yearLst;
};

export const fillDays = () => {
  let dayLst = [];
  for (let day = 1; day <= 31; day++) {
    dayLst.push({
      index: day,
      Name: day,
    });
  }
  return dayLst;
};
export const createDate = (date) => {
  if (this.props.language.direction === 'ltr')
    return new Date(date).toISOString().split('T')[0].split('-');
  else
    return momentjs(
      new Date(date).toISOString().split('T')[0],
      DATE_FORMAT_MOMENT_SHAMSI,
    )
      .format(DATE_FORMAT_MOMENT_SHAMSI_JALALI)
      .split('-');
};
export const getDayDiff = (date1, date2) => {
  var timeDiff =
    new Date(date2.split('T')[0]).getTime() -
    new Date(date1.split('T')[0]).getTime();

  return Math.floor(timeDiff / (1000 * 3600 * 24));
};

//ایجاد تاریخ استاندارد بصورت 2019-09-09
export const getStringDate = (date) => {
  let dd = date.split('-');
  return `${addZero(dd[0])}-${addZero(dd[1])}-${addZero(dd[2])}`;
};
//افزودن صفر با ماه و روز برای تاریخ ها
export const addZero = (number) => {
  if (number.toString().length === 1) return `0${number}`;
  else return number;
};
//برگرداندن نام هفته شمسی یا میلادی
export const returnWeeekDay = (date, name, isShort) => {
  let monthIndex =
    returnWeekDays('en').indexOf(
      momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('dddd').substring(0, 3),
    ) + 1;

  return name === 'fa'
    ? returnWeekDays('fa')[monthIndex > 6 ? 0 : monthIndex]
    : isShort
    ? momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('dddd').substring(0, 3)
    : momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('dddd');
};
// برگرداندن روز براساس زبان
export const returnDay = (name, date) => {
  if (name === 'fa' && date) {
    let shamsiDate = momentjs(date, 'YYYY-MM-DD').format(
      DATE_FORMAT_MOMENT_SHAMSI_JALALI,
    );
    return momentjs(shamsiDate, DATE_FORMAT_MOMENT_SHAMSI_JALALI).format('jDD');
  } else return momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('DD');
};
// برگرداندن سال از تاریخ ارسالی و زبان
export const returnYear = (name, date) => {
  if (name === 'fa') {
    let shamsiDate = momentjs(date, 'YYYY-MM-DD').format(
      DATE_FORMAT_MOMENT_SHAMSI_JALALI,
    );

    return momentjs(shamsiDate, DATE_FORMAT_MOMENT_SHAMSI_JALALI).format(
      'jYYYY',
    );
  } else return momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('YYYY');
};
// برگرداندن نام ماه براساس تاریخ و زبان ارسالی
export const returnMonthName = (laguageName, date) => {
  let shamsiMonth = momentjs(date, 'YYYY-MM-DD').format('jMM');
  if (laguageName === 'fa') return shamsiMonthList[parseInt(shamsiMonth) - 1];
  else return momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format('MMM');
};

export const returnShamsiDateWithWeek = (date) => {
  let shamsiDate = momentjs(date, DATE_FORMAT_MOMENT_SHAMSI).format(
    DATE_FORMAT_MOMENT_SHAMSI_JALALI,
  );

  let shamsiArr = shamsiDate.split('-');

  return `${returnWeeekDay(date, 'fa', false)} ${
    shamsiArr[2]
  } ${returnMonthName('fa', date)} ${shamsiArr[0]}`;
};

export const returnShamsiDate = (date, name) => {
  date = momentjs(date, DATE_FORMAT_MOMENT_SHAMSI)
    .format(DATE_FORMAT_MOMENT_SHAMSI_JALALI)
    .split('-');

  let monthName = monthNames['rtl'][name][parseInt(date[1] - 1)];

  return `${parseInt(date[2])} ${monthName} ${date[0]}`;
};
export const returnDateWithMonthName = (date, name) => {
  date = date.split('-');
  return `${date[2]} ${
    name === 'fa'
      ? monthNames['ltr'][name][date[1] - 1]
      : monthNames['ltr'][name][date[1] - 1].substring(0, 3)
  } ${date[0]} `;
};
export const returnDayWithMonthName = (date, name) => {
  date = date.split('-');
  return `${date[2]} ${
    name === 'fa'
      ? monthNames['ltr'][name][date[1] - 1]
      : monthNames['ltr'][name][date[1] - 1].substring(0, 3)
  }`;
};
export const returnShamsiDayWithMonthName = (date, name) => {
  if (date?.includes('-')) {
    date = date?.split('-');
    return `${date[2]} ${monthNames['rtl'][name][date[1] - 1]}`;
  } else return date;
};
export const returnValidationType = (type, otherCountry, validationTypes) => {
  let validationType = '';
  switch (type) {
    case 'nationalCode':
      validationType = otherCountry
        ? validationTypes.optional
        : validationTypes.nationalCode;
      break;
    case 'passportNo':
      validationType = otherCountry
        ? validationTypes.requierdAlphabet
        : validationTypes.optional;
      break;
    case 'passportExpireYear':
      validationType = otherCountry
        ? validationTypes.requiredNumber
        : validationTypes.optional;
      break;
    case 'passportExpireDay':
      validationType = otherCountry
        ? validationTypes.requiredNumber
        : validationTypes.optional;
      break;
    case 'passportExpireMonth':
      validationType = otherCountry
        ? validationTypes.requiredNumber
        : validationTypes.optional;
      break;
    case 'passportExpireDate':
      validationType = otherCountry
        ? validationTypes.requierdDate
        : validationTypes.optional;
      break;
    default:
      validationType = validationTypes.optional;
      break;
  }
  return validationType;
};
export const checkSameAirport = (selectedAirport) => {
  if (selectedAirport && selectedAirport.length > 0) {
    let hasSameAirport = selectedAirport.map((item) => {
      if (
        item.origin &&
        item.origin.hasOwnProperty('city') &&
        item.destination &&
        item.destination.hasOwnProperty('city')
      )
        return (
          item.origin.city.locationName.en ===
            item.destination.city.locationName.en ||
          !item.origin.city.locationName ||
          !item.destination.city.locationName
        );
      else {
        return true;
      }
    });
    if (hasSameAirport.indexOf(true) > -1) return true;
    else return false;
  } else return false;
};
export const createEachFlight = () => {
  let itineraries = [];
  let selectedAirport = JSON.parse(sessionStorage.getItem('selectedAirport'));
  if (selectedAirport && selectedAirport.length > 0)
    selectedAirport.map((item) => {
      itineraries.push({
        originCountryCode: item.origin.countryCode,
        destinationCountryCode: item.destination.countryCode,
        origin: item.origin.isLocation
          ? item.origin.locationCode
          : item.origin.city.iata,
        isOriginLocation: item.origin.isLocation,
        destination: item.destination.isLocation
          ? item.destination.locationCode
          : item.destination.city.iata,
        isDestinationLocation: item.destination.isLocation,
        departDate: item.date && item.date.miladi.join('-'),
      });
    });

  return itineraries;
};
export const checkInternationlMultiCity = (selectedAirport) => {
  return selectedAirport.every(
    (item) =>
      item.destination.countryCode !== 'IR' && item.origin.countryCode !== 'IR',
  ).length > 0
    ? false
    : selectedAirport.every(
        (item) =>
          item.destination.countryCode === 'IR' &&
          item.origin.countryCode === 'IR',
      ).length > 0
    ? true
    : null;
};
export const checkInternationl = (selectedAirport) => {
  let isInternational = [];
  if (selectedAirport && selectedAirport.length) {
    if (
      !selectedAirport.some((t) => t.origin) ||
      !selectedAirport.some((t) => t.destination) ||
      selectedAirport.some((t) => Object.keys(t.origin).length === 0) ||
      selectedAirport.some((t) => Object.keys(t.destination).length === 0)
    ) {
      return false;
    } else {
      isInternational = selectedAirport.map((item) => {
        if (
          (item.destination && item.destination.isInternational === true) ||
          (item.origin && item.origin.isInternational === true)
        ) {
          return true;
        } else return false;
      });
    }
  } else {
    isInternational = false;
  }

  return isInternational.some((item) => item === true);
};
export const checkInternationlInMobile = (selectedAirport) => {
  let isInternational = [];
  if (selectedAirport && selectedAirport.length) {
    if (
      !selectedAirport.some((t) => t.origin) ||
      !selectedAirport.some((t) => t.destination) ||
      selectedAirport.some((t) => Object.keys(t.origin).length === 0) ||
      selectedAirport.some((t) => Object.keys(t.destination).length === 0)
    ) {
      return false;
    } else {
      isInternational = selectedAirport.map((item) => {
        if (
          (item.destination && item.destination.countryCode !== 'IR') ||
          (item.origin && item.origin.countryCode !== 'IR')
        ) {
          return true;
        } else return false;
      });
    }
  } else {
    isInternational = false;
  }
  return isInternational.some((item) => item === true);
};
export const checkAirportHasAllProperty = (airport) => {
  if (airport)
    return (
      airport.hasOwnProperty('origin') &&
      airport.origin.hasOwnProperty('city') &&
      airport.hasOwnProperty('destination') &&
      airport.destination.hasOwnProperty('city') &&
      airport.origin.city.hasOwnProperty('locationName') &&
      airport.destination.city.hasOwnProperty('locationName')
    );
  else return false;
};

export const getPreviousePage = (currentPage) => {
  const currentIndex = flightPage.findIndex(
    (item) => item.path === currentPage,
  );

  return currentIndex >= 0
    ? flightPage[currentIndex - 1].route
    : flightPage[0].route;
};
export const returnFlightType = (
  selectedAirport,
  parsedQueryStr,
  flightTypeState,
) => {
  let flightType = 'roundtrip';
  if (!!parsedQueryStr.ft) {
    flightType = flightTypeState;
    console.log('datata : ', flightType);
    if (flightType === 'multicity') {
      const selectedAirportNumber = selectedAirport.length;
      flightType = checkFlightTypeByAirports(selectedAirport);
      if (selectedAirportNumber > 2) {
        flightType = 'multicity';
      } else if (selectedAirportNumber === 2) {
        flightType = checkFlightTypeByAirports(selectedAirport);
      } else {
        flightType = 'onewaytrip';
      }
    }
  } else {
    flightType = checkFlightTypeByAirports(selectedAirport);
  }
  return flightType;
};

const checkFlightTypeByAirports = (selectedAirport) => {
  let flightType = 'roundtrip';
  switch (selectedAirport.length) {
    case 0:
      flightType = 'roundtrip';
    case 1:
      flightType = 'onewaytrip';
      break;
    case 2:
      flightType =
        isFlightRoundTrip(selectedAirport) || hasEmptyRoutes(selectedAirport)
          ? 'roundtrip'
          : 'multicity';
      break;

    default:
      flightType = 'multicity';
      break;
  }
  return flightType;
};
const isFlightRoundTrip = (selectedAirport) => {
  const firstAirport = selectedAirport[0],
    secondAirport = selectedAirport[1];
  if (selectedAirport.length === 2)
    if (
      checkAirportHasAllProperty(firstAirport) &&
      checkAirportHasAllProperty(secondAirport)
    ) {
      if (
        firstAirport.origin.city.iata === secondAirport.destination.city.iata &&
        firstAirport.destination.city.iata === secondAirport.origin.city.iata
      )
        return true;
    } else {
      if (firstAirport.origin === '' || firstAirport.destination === '')
        return true;
    }
};
const hasEmptyRoutes = (selectedAirport) => {
  const firstAirport = selectedAirport[0],
    secondAirport = selectedAirport[1];
  if (
    Object.keys(firstAirport.origin).length === 0 &&
    Object.keys(firstAirport.destination).length === 0 &&
    Object.keys(secondAirport.destination).length === 0 &&
    Object.keys(secondAirport.origin).length === 0
  )
    return true;
  else return false;
};
export const clearLocalStorage = () => {
  sessionStorage.removeItem('selectFlight');
  sessionStorage.removeItem('flightResult');
  sessionStorage.removeItem('passengers');
  localStorage.removeItem('token');
  sessionStorage.removeItem('issuerContactInfo');
  sessionStorage.removeItem('searchTime');
  sessionStorage.removeItem('calendarPrice');
  //remove holiday data
  Object.keys(sessionStorage).forEach((element) => {
    if (element.startsWith('holidayList-')) {
      sessionStorage.removeItem(element);
    }
  });
};

export const convertToCamelCase = (object) => {
  var newObject, origKey, newKey, value;
  if (object instanceof Array) {
    return object.map(function (value) {
      if (typeof value === 'object') {
        value = convertToCamelCase(value);
      }
      return value;
    });
  } else {
    newObject = {};
    for (origKey in object) {
      if (object.hasOwnProperty(origKey)) {
        newKey = (
          origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
        ).toString();
        value = object[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = convertToCamelCase(value);
        }
        newObject[newKey] = value;
      }
    }
  }
  return newObject;
};

//should pass item.flights from booking table as a item
export const createDetailPriceList = (
  item,
  totalPrice,
  commission,
  passengers,
  languageName,
) => {
  let priceList = [];

  if (item.itineraries.filter((item) => item?.price).length > 0) {
    item.itineraries.forEach((element) => {
      let flightName = `${
        element?.flights?.[0]?.departureAirport?.cityName?.[languageName]
      }-${
        element.flights[element.flights.length - 1].arrivalAirport?.cityName?.[
          languageName
        ]
      }`;
      priceList.push({
        key: 'Adult',
        ...element?.price?.adultPrice,
        flightName,
      });
      if (
        element.price.childPrice &&
        element.price.childPrice.totalPrice > 0 &&
        item.childCount > 0
      )
        priceList.push({
          key: 'Child',
          ...element.price.childPrice,
          flightName,
        });
      if (
        element.price.infantPrice &&
        element.price.infantPrice.totalPrice > 0 &&
        item.infantCount > 0
      )
        priceList.push({
          key: 'Infant',
          ...element.price.infantPrice,
          flightName,
        });
      priceList.push({
        key: 'Total',
        TotalPrice: totalPrice,
        flightName,
      });
      priceList.push({
        key: 'Total',
        TotalPrice: totalPrice,
        flightName,
        Commission: commission || 0,
      });
    });
  } else {
    if (item.adultPrice) {
      priceList.push({ key: 'Adult', ...item.adultPrice });
      if (
        item.childPrice &&
        item.childPrice.totalPrice > 0 &&
        item.childCount > 0
      )
        priceList.push({ key: 'Child', ...item.childPrice });
      if (
        item.infantPrice &&
        item.infantPrice.totalPrice > 0 &&
        item.infantCount > 0
      )
        priceList.push({ key: 'Infant', ...item.infantPrice });
      priceList.push({
        key: 'Total',
        TotalPrice: totalPrice,
        Commission: commission || 0,
      });
    } else {
      passengers.forEach((element) => {
        if (
          element.type === 'adult' &&
          priceList.filter((item) => item.key === 'Adult').length === 0
        ) {
          priceList.push({ key: 'Adult', ...element.price });
        }
        if (
          element.type === 'child' &&
          priceList.filter((item) => item.key === 'Child').length === 0
        ) {
          priceList.push({ key: 'Child', ...element.price });
        }

        if (
          element.type === 'infant' &&
          priceList.filter((item) => item.key === 'Infant').length === 0
        ) {
          priceList.push({
            key: 'Infant',
            ...element.price,
          });
        }
      });
      priceList.push({
        key: 'Total',
        TotalPrice: totalPrice,
        Commission: commission || 0,
      });
    }
  }
  return priceList;
};
//should pass item.Flights from gateway search  as a item (for search data before insert in table with UpperCase fileds)
export const createDetailPriceListFlight = (
  item,
  parsedQueryStr,
  languageName,
) => {
  let priceList = [];
  //for internal flight we have price of each flight so we add flight name to list
  if (item?.Itineraries.filter((item) => item?.Price).length > 0) {
    item.Itineraries.forEach((itenery) => {
      let flightName = `${
        itenery?.Flights[0]?.DepartureAirport?.CityName?.[languageName]
      }-${itenery?.Flights?.at(-1)?.ArrivalAirport?.CityName?.[languageName]}`;
      priceList.push({ key: 'Adult', ...itenery.Price.AdultPrice, flightName });
      if (itenery?.Price?.ChildPrice?.TotalPrice > 0 && parsedQueryStr.ch > 0)
        priceList.push({
          key: 'Child',
          ...itenery?.Price?.ChildPrice,
          flightName,
        });
      if (itenery?.Price?.InfantPrice?.TotalPrice > 0 && parsedQueryStr.in > 0)
        priceList.push({
          key: 'Infant',
          ...itenery?.Price?.InfantPrice,
          flightName,
        });

      priceList.push({
        key: 'Total',
        TotalPrice: item?.TotalPrice,
        flightName,
        Commission: item?.Commission || 0,
      });
    });
  } else {
    priceList.push({ key: 'Adult', ...item?.AdultPrice });
    if (item?.ChildPrice?.TotalPrice > 0)
      priceList.push({ key: 'Child', ...item?.ChildPrice });
    if (item?.InfantPrice?.TotalPrice > 0)
      priceList.push({ key: 'Infant', ...item?.InfantPrice });
    priceList.push({
      key: 'Total',
      TotalPrice: item?.TotalPrice,
      Commission: item?.Commission || 0,
    });
  }
  return priceList;
};
export const setIconBYSortType = (sortType = 'clockIcon') => {
  switch (sortType) {
    case 'time':
      return 'clockIcon';
    case 'arrivetime':
      return 'durationIcon';
    case 'price':
      return 'usdCircleIcon';
    case 'point':
      return 'coinIcon';
    case 'duration':
      return 'stopwatchIcon';
    default:
      return 'clockIcon';
  }
};
export const createItineraries = (selectFlight) => {
  let itineraries = [];
  selectFlight.itineraries.map((item, index) => {
    itineraries.push({
      index,
      price: { ...item.price, salesPolicyId: item.salesPolicyId },
      gateway: item.gateway,
      refNumber: item.refNumber,
      directionId: item.directionId,
      elapsedTime: item.elapsedTime,
      totalStopTime: item.totalStopTime,
      stopCount: item.stopCount,
      originalPrice: item.originalPrice ? item.originalPrice : null,
      flights: createFlights(item),
      isCharter: item.isCharter,
      isReserveAvailable: item.isReserveAvailable,
    });
  });
  return itineraries;
};
export const createFlights = (item) => {
  let flightList = [];
  item.flights.map((flight) => {
    flightList.push({
      gatewayData: flight.gatewayData ? flight.gatewayData : null,
      departureAirport: flight.departureAirport,
      arrivalAirport: flight.arrivalAirport,
      marketingAirline: flight.marketingAirline,
      operatingAirline: flight.operatingAirline,
      equipment: flight.equipment,
      baggage: flight.baggage,
      stopLocation: flight.stopLocation,
      departureDateTime: flight.departureDateTime,
      arrivalDateTime: flight.arrivalDateTime,
      flightNumber: flight.flightNumber,
      resBookDesigCode: flight.resBookDesigCode,
      flightDuration: flight.flightDuration,
      resBookDesigCabinCode: flight.bookingClassAvails.resBookDesigCabinCode,
      fareBasis: flight.bookingClassAvails.fareBasis,
      fareType: flight.bookingClassAvails.fareType,
      resBookDesigCabinName: flight.bookingClassAvails.resBookDesigCabinName,
      RPH: flight.bookingClassAvails.rPH ? flight.bookingClassAvails.rPH : '',
    });
  });
  return flightList;
};
export const hasPrevSameAirport = (flightList, index, name, item) => {
  return (
    flightList.itineraries[index - 1] &&
    flightList.itineraries[index - 1].flights[
      flightList.itineraries[index - 1].flights.length - 1
    ].arrivalAirport.name[name] === item.flights[0].departureAirport.name[name]
  );
};

export const returnInvoiceDate = (dateTime, name, intl) => {
  let date = dateTime.split('T'),
    monthName = returnMonthName(name, date[0]),
    dayName = returnWeeekDay(date[0], name, true),
    yearName = returnYear(name, date),
    day = returnDay(name, date);
  return `${dayName} ${day} ${monthName} ${yearName} ${
    name === 'fa'
      ? intl.formatMessage({
          id: 'booking.at',
        })
      : 'AT'
  } ${date[1].substring(0, 5)}`;
};
export const returnDayAndMonthName = (dateTime, name) => {
  let date = dateTime.split('T'),
    monthName = returnMonthName(name, date[0]),
    day = returnDay(name, date);
  return `${day} ${monthName} `;
};
export const returnDateWithWeek = (dateTime, name) => {
  if (dateTime) {
    try {
      let date = dateTime.split('T'),
        monthName = returnMonthName(name, date[0]),
        dayName = returnWeeekDay(date[0], name, true),
        yearName = returnYear(name, date),
        day = returnDay(name, date);
      return `${dayName} ${day} ${monthName} ${yearName} `;
    } catch {
      return '';
    }
  } else return '';
};
export const returnDateWihWeekName = (dateTime, name) => {
  let date = dateTime.split('T'),
    monthName = returnMonthName(name, date[0]),
    weekName = returnWeeekDay(date[0], name, true),
    day = returnDay(name, date);
  return `${weekName}, ${day} ${monthName} `;
};
export const returnFlightDate = (dateTime, name, showDayName) => {
  if (dateTime) {
    let date = dateTime.split('T'),
      monthName = returnMonthName(name, date[0]),
      dayName = returnWeeekDay(date[0], name, true),
      yearName = returnYear(name, date),
      day = returnDay(name, date);
    return `${showDayName ? dayName : ''} ${day} ${monthName} ${yearName} `;
  } else return '';
};
export const returnMonthDay = (dateTime, name) => {
  let date = dateTime.split('T'),
    monthName = returnMonthName(name, date[0]),
    day = returnDay(name, date);
  return `${day} ${monthName} `;
};

//برگرداندن تاریخ با فرمت 05-05-2019
export const returnMiladiDateByStandardFormat = (date) => {
  return date
    ? momentjs(new Date(date).toLocaleDateString(), 'M/D/YYYY').format(
        'YYYY-MM-DD',
      )
    : '';
};
export const returnShamsiDateByStandardFormat = (date) => {
  return date
    ? momentjs(new Date(date).toLocaleDateString(), 'M/D/YYYY').format(
        'jYYYY-jMM-jDD',
      )
    : '';
};
// show stop time with message
export const returnFormatTime = (time, direction, intl, shortTerm = false) => {
  let hour = parseInt(time.split(':')[0]);
  let min = parseInt(time.split(':')[1]);

  return hour > 0
    ? min > 0
      ? direction === 'rtl'
        ? time
        : `${hour}  ${
            shortTerm
              ? 'h'
              : intl.formatMessage({
                  id: 'booking.hour',
                })
          }${direction === 'ltr' && hour > 1 && !shortTerm ? `s` : ''}  ${
            shortTerm
              ? ','
              : intl.formatMessage({
                  id: 'booking.and',
                })
          } ${min} ${
            shortTerm
              ? 'm'
              : intl.formatMessage({
                  id: 'booking.minutes',
                })
          } `
      : `${hour} ${intl.formatMessage({ id: 'booking.hour' })}${
          direction === 'ltr' && hour > 1 ? `s` : ''
        }`
    : `${min}  ${intl.formatMessage({
        id: 'booking.minutes',
      })}`;
};

//sort flight by sent parameter
export const sortFlightFunc = (flightList, sortBy, sortType) => {
  if (flightList && flightList.length > 0) {
    let columnName = '';
    let columnType = '';
    switch (sortBy) {
      case 'time':
        columnName = 'Itineraries[0].Flights[0].DepartureDateTime';
        columnType = 'Date';
        break;
      case 'price':
        columnName = 'FinalPrice';
        columnType = 'Number';

        break;
      case 'arrivetime':
        columnName =
          'Itineraries[0].Flights[Flights[length - 1]].ArrivalDateTime';

        // columnName = (o) =>
        //   o.Itineraries[0].Flights[o.Itineraries[0].Flights.length - 1]
        //     .ArrivalDateTime;
        columnType = 'ArriveDate';
        break;
      case 'duration':
        columnName = 'Itineraries[0].ElapsedTime';
        columnType = 'Date';
        break;
      case 'point':
        columnName = 'Derik';
        columnType = 'Number';
        break;
      default:
        columnName = 'FinalPrice';
        columnType = 'Number';

        break;
    }
    if (flightList.length > 0) {
      flightList = orderBy(
        flightList,
        columnName.toString(),
        columnType,
        sortType,
      );
      return flightList;
    }
  }
};
export const filterFunction = (
  selectedAirport,
  selectedFilter,
  flightList,
  sortBy,
  sortType,
  flightType,
  name,
) => {
  for (let index = 0; index < selectedAirport.length; index++) {
    if (
      selectedFilter.flightNumberSelected.length &&
      selectedFilter.flightNumberSelected[index]
    ) {
      flightList = filterFlightByFlightNumber(
        selectedFilter.flightNumberSelected,
        index,
        flightList,
        name,
      );
    }

    if (
      selectedFilter.providerSelected[index] &&
      selectedFilter.providerSelected[index].length > 0
    ) {
      flightList = filterFlightByProvider(
        selectedFilter.providerSelected,
        index,
        flightList,
        name,
      );
    }

    if (
      selectedFilter.timeSelected[index] &&
      Object.entries(selectedFilter.timeSelected[index]).length > 0
    )
      flightList = filterFlightByTime(
        selectedFilter.timeSelected,
        index,
        flightList,
        name,
      );

    if (Object.keys(selectedFilter.priceRangeSelected).length !== 0)
      flightList = filterFlightByPrice(
        selectedFilter.priceRangeSelected,
        flightList,
        name,
      );
    if (
      selectedFilter.durationSelected[index] &&
      selectedFilter.durationSelected[index].min
    )
      flightList = filterFlightByDepartDuration(
        selectedFilter.durationSelected,
        index,
        flightList,
        name,
      );
    if (
      selectedFilter.airlineSelected[index] &&
      selectedFilter.airlineSelected[index].length > 0
    ) {
      flightList = filterFlightByAirLine(
        selectedFilter.airlineSelected,
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.layoverAirportSelected[index] &&
      selectedFilter.layoverAirportSelected[index].length > 0
    ) {
      flightList = filterFlightByLayOverAirport(
        selectedFilter.layoverAirportSelected,
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.airportSelected[index] &&
      selectedFilter.airportSelected[index].length > 0
    ) {
      flightList = filterFlightByAirport(
        selectedFilter.airportSelected,
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.arrivalAirportSelected[index] &&
      selectedFilter.arrivalAirportSelected[index].length > 0
    ) {
      flightList = filterFlightByArrivalAirport(
        selectedFilter.arrivalAirportSelected,
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.baggageSelected[index] &&
      selectedFilter.baggageSelected[index].length > 0
    ) {
      flightList = filterFlightByBaggage(
        selectedFilter.baggageSelected[index],
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.charterSelected[index] &&
      selectedFilter.charterSelected[index].length > 0
    ) {
      flightList = filterFlightByCharter(
        selectedFilter.charterSelected[index],
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.charterSelected[index] &&
      selectedFilter.charterSelected[index].length > 0
    ) {
      flightList = filterFlightByCharter(
        selectedFilter.charterSelected[index],
        index,
        flightList,
        name,
      );
    }
    if (
      selectedFilter.cabinSelected[index] &&
      selectedFilter.cabinSelected[index].length > 0
    ) {
      flightList = filterFlightByCabin(
        selectedFilter.cabinSelected[index],
        index,
        flightList,
        name,
      );
    }
    //create disable list

    if (
      selectedFilter.stopCountSelected[index] &&
      selectedFilter.stopCountSelected[index].length > 0
    ) {
      flightList = filterFlightByStopCount(
        selectedFilter.stopCountSelected[index],
        index,
        flightList,
        name,
      );
    }
  }
  flightList = sortFlightFunc(flightList, sortBy, sortType, flightType);

  return flightList;
};
export const filterFlightByPrice = (priceRangeSelected, flightList) => {
  let flights = [],
    min = 0,
    max = 0;
  if (Object.keys(priceRangeSelected).length !== 0) {
    min = parseInt(priceRangeSelected.min);
    max = parseInt(priceRangeSelected.max);
    flights = flightList.filter((item) => {
      let result = false;
      // if (
      //   parseInt(item.AdultPrice.TotalPrice) / 260000 >= min &&
      //   parseInt(item.AdultPrice.TotalPrice) / 260000 <= max
      // )
      if (
        parseInt(item.AdultPrice.TotalPrice / 10).toFixed(0) >= min &&
        parseInt(item.AdultPrice.TotalPrice / 10).toFixed(0) <= max
      )
        result = true;

      return result;
    });
    return flights;
  }
};
export const filterFlightByDepartDuration = (
  durationSelected,
  index,
  flightList,
) => {
  let flights = [];
  if (
    durationSelected[index] &&
    Object.entries(durationSelected[index]).length
  ) {
    let min = parseInt(durationSelected[index].min);
    let max = parseInt(durationSelected[index].max);

    flights = flightList.filter((item) => {
      let result = false;
      if (
        (parseInt(item.Itineraries[index].flightDuration.substring(0, 2)) >=
          min &&
          parseInt(item.Itineraries[index].flightDuration.substring(0, 2)) <
            max) ||
        (parseInt(item.Itineraries[index].flightDuration.substring(0, 2)) ===
          max &&
          parseInt(item.Itineraries[index].flightDuration.substring(2, 4)) ===
            0)
      ) {
        result = true;
      }

      return result;
    });
  }

  return flights;
};

export const filterFlightByTime = (timeSelected, index, flightList) => {
  let flights = [];
  if (timeSelected[index].length !== 0) {
    let min = '0';
    let max = '24';

    min = parseInt(timeSelected[index].min);
    max = parseInt(timeSelected[index].max);

    flightList.filter((time) => {
      let departDate =
        time.Itineraries[index].Flights[0].DepartureDateTime.split(
          'T',
        )[1].split(':');
      let hours = parseInt(departDate[0]),
        minute = parseInt(departDate[1]);
      if (hours >= min && hours <= max) {
        if (!(hours == max && minute != 0)) flights.push(time);
      }
    });
  }

  return flights;
};
export const filterFlightByCharter = (charterSelected, index, flightList) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;

    if (
      charterSelected.indexOf(item.Itineraries[index].isCharter.toString()) !==
      -1
    ) {
      result = true;
    }

    return result;
  });
  return flights;
};
export const filterFlightByBaggage = (baggageSelect, index, flightList) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;
    item.Itineraries[index].Flights.map((flight) => {
      if (
        baggageSelect.indexOf(
          flight.Baggage.filter((item) => item.Type === 'ADT')[0].Index,
        ) !== -1
      ) {
        result = true;
      }
    });
    return result;
  });
  return flights;
};
export const filterFlightByCabin = (cabinSelet, index, flightList, name) => {
  let flights = [];

  flights = flightList.filter((item) => {
    let result = false;
    item.Itineraries[index].Flights.map((flight) => {
      if (
        cabinSelet.indexOf(
          flight.BookingClassAvails.ResBookDesigCabinName[name],
        ) !== -1
      ) {
        result = true;
      }
    });
    return result;
  });
  return flights;
};
export const filterFlightByStopCount = (stopCount, index, flightList) => {
  let flights = [];

  flights = flightList.filter((item) => {
    let result = false;
    if (
      stopCount.indexOf(item.Itineraries[index].StopCount.toString()) !== -1
    ) {
      result = true;
    }
    return result;
  });
  return flights;
};
export const filterFlightByLayOverAirport = (
  layOverAirport,
  index,
  flightList,
) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;

    item.Itineraries[index].Flights.map((flight) => {
      if (layOverAirport[index].indexOf(flight.DepartureAirport.Code) !== -1) {
        result = true;
      }
    });

    return result;
  });

  return flights;
};
export const filterFlightByAirport = (airport, index, flightList) => {
  let flights = [];

  flights = flightList.filter((item) => {
    let result = false;

    item.Itineraries[index].Flights.map((flight) => {
      if (airport[index].indexOf(flight.DepartureAirport.Code) !== -1) {
        result = true;
      }
    });

    return result;
  });

  return flights;
};
export const filterFlightByArrivalAirport = (
  airport,
  index,
  flightList,
  name,
) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;

    item.Itineraries[index].Flights.map((flight) => {
      if (airport[index].indexOf(flight.ArrivalAirport.Code) !== -1) {
        result = true;
      }
    });

    return result;
  });

  return flights;
};
export const filterFlightByAirLine = (
  airlineSelected,
  index,
  flightList,
  name,
) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;

    item.Itineraries[index].Flights.map((flight) => {
      if (
        airlineSelected[index].indexOf(flight.MarketingAirline.Name[name]) !=
          -1 ||
        airlineSelected[index].indexOf(flight.OperatingAirline.Name[name]) !==
          -1
      ) {
        result = true;
      }
    });

    return result;
  });

  return flights;
};
export const filterFlightByProvider = (providerSelected, index, flightList) => {
  let flights = [];
  flights = flightList.filter((item) => {
    let result = false;
    item.Itineraries.map((itenery, indx) => {
      if (indx === index) {
        if (
          providerSelected[index].indexOf(itenery.Gateway.id.toString()) != -1
        ) {
          result = true;
        }
      }
    });

    return result;
  });

  return flights;
};

export const filterFlightByFlightNumber = (
  flightNumberSelected,
  index,
  flightList,
) => {
  let flights = [];

  flights = flightList.filter((item) => {
    let result = false;

    item.Itineraries[index].Flights.map((flight) => {
      if (
        flight.FlightNumber.toLowerCase().includes(
          flightNumberSelected[index].toLowerCase(),
        )
      ) {
        result = true;
      }
    });

    return result;
  });

  return flights;
};
export const returnPaymentType = (paymentInfo, intl) => {
  let paymentsType = [];
  if (paymentInfo && paymentInfo.type) {
    paymentsType = [...paymentInfo.type];
    let finalType = [];
    paymentsType.forEach((element) => {
      if (element === 'credit')
        finalType.push(
          intl.formatMessage({
            id: 'booking.fromcredit',
          }),
        );
      if (element === 'wallet')
        finalType.push(
          intl.formatMessage({
            id: 'booking.fromwallet',
          }),
        );
      if (element === 'point')
        finalType.push(
          intl.formatMessage({
            id: 'booking.frompoint',
          }),
        );
      if (element === 'bank' || element === '')
        finalType.push(
          intl.formatMessage({
            id: 'booking.online',
          }),
        );
      if (element === 'reserve')
        finalType.push(
          intl.formatMessage({
            id: 'booking.temporaryreservation',
          }),
        );
    });
    if (finalType.length > 1) return finalType.join(',');
    else return finalType?.[0] ?? '--';
  } else if (paymentInfo.type === '')
    return intl.formatMessage({
      id: 'booking.online',
    });
  else return '--';
};
export const checkNationalCode = (melliCode) => {
  let identicalDigits = [
    '0000000000',
    '1111111111',
    '2222222222',
    '3333333333',
    '4444444444',
    '5555555555',
    '6666666666',
    '7777777777',
    '8888888888',
    '9999999999',
  ];
  if (melliCode.trim().isEmpty()) {
    return false; // Melli Code is empty
  } else if (melliCode.length != 10) {
    return false; // Melli Code is less or more than 10 digits
  } else if (identicalDigits.includes(melliCode)) {
    return false; // Fake Melli Code
  } else {
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += melliCode.charAt(i) * (10 - i);
    }

    let lastDigit;
    let divideRemaining = sum % 11;

    if (divideRemaining < 2) {
      lastDigit = divideRemaining;
    } else {
      lastDigit = 11 - divideRemaining;
    }

    if (melliCode.charAt(9) == lastDigit) {
      return true;
    } else {
      return false; // Invalid MelliCode
    }
  }
};
export const returnDirection = (itineraries, name) => {
  let direction = '',
    sameAirport = false;
  itineraries.map((item, index) => {
    let directionArray = direction.split('-');

    directionArray.length > 0 &&
    directionArray[directionArray.length - 1].includes(
      item.flights[0].departureAirport.cityName[name],
    )
      ? (sameAirport = true)
      : (sameAirport = false);

    direction += ` ${
      sameAirport
        ? ''
        : item.flights[0].departureAirport.cityName[name]
        ? item.flights[0].departureAirport.cityName[name]
        : item.flights[0].departureAirport.cityName['en']
    }
      - ${
        item.flights[item.flights.length - 1].arrivalAirport.cityName[name]
          ? item.flights[item.flights.length - 1].arrivalAirport.cityName[name]
          : item.flights[item.flights.length - 1].arrivalAirport.cityName['en']
      }`;
  });
  return direction;
};
export const returnDirectionCode = (itineraries, name) => {
  let direction = '',
    sameAirport = false;
  itineraries.map((item, index) => {
    let directionArray = direction.split('-');

    directionArray.length > 0 &&
    directionArray[directionArray.length - 1].includes(
      item.flights[0].departureAirport.code,
    )
      ? (sameAirport = true)
      : (sameAirport = false);

    direction += ` ${sameAirport ? '' : item.flights[0].departureAirport.code}
      - ${item.flights[item.flights.length - 1].arrivalAirport.code}`;
  });
  return direction;
};
export const returnAirlineLogos = (airlineCode) => {
  try {
    return `${fileHandlerUrl}/icons/airlines/${airlineCode}.png`;
  } catch (error) {
    return `${fileHandlerUrl}/icons/airlines/Airplane.png`;
  }
};

export const updateRoute = (prop, value, mainRoute, parsedQueryStr) => {
  parsedQueryStr[prop] = value;
  return `${mainRoute}?${new URLSearchParams(parsedQueryStr).toString()}`;
};

export const getValue = (obj, query) => {
  let qur = query.split('.');
  return qur.reduce((acc, item) => {
    let spl = item.split('[');
    if (spl.length == 2)
      return acc[spl[0]][spl[1].substring(0, spl[1].length - 1)];
    else if (spl.length > 2) return acc.Flights.at(-1);
    return acc[spl[0]];
  }, obj);
};
export const orderBy = (list, query, queryType = 'String', order = 'asc') => {
  if (order === 'asc') {
    if (queryType == 'String')
      return list.sort((a, b) =>
        getValue(a, query).localeCompare(getValue(b, query)),
      );
    else if (queryType == 'Date')
      return list.sort(
        (a, b) => new Date(getValue(a, query)) - new Date(getValue(b, query)),
      );
    else if (queryType == 'Number')
      return list.sort(
        (a, b) =>
          parseFloat(getValue(a, query)) - parseFloat(getValue(b, query)),
      );
    else if (queryType == 'ArriveDate')
      return list.sort(
        (a, b) => new Date(getValue(a, query)) - new Date(getValue(b, query)),
      );
    return list.sort((a, b) => getValue(a, query) - getValue(b, query));
  } else {
    if (queryType == 'String')
      return list.sort((a, b) =>
        getValue(b, query).localeCompare(getValue(a, query)),
      );
    else if (queryType == 'Date')
      return list.sort(
        (a, b) => new Date(getValue(b, query)) - new Date(getValue(a, query)),
      );
    else if (queryType == 'Number')
      return list.sort(
        (a, b) =>
          parseFloat(getValue(b, query)) - parseFloat(getValue(a, query)),
      );
    else if (queryType == 'ArriveDate')
      return list.sort(
        (a, b) => new Date(getValue(b, query)) - new Date(getValue(a, query)),
      );
    return list.sort((a, b) => getValue(b, query) - getValue(a, query));
  }
};
export const returnSeperateFlight = (initialFlightList) => {
  let availsFlights = [],
    notAvailsFlights = [],
    previousIndexList = [];

  if (initialFlightList) {
    initialFlightList.map((item, index) =>
      item.Itineraries.map((itinerary) =>
        itinerary.Flights.map((flight) => {
          if (
            flight.BookingClassAvails.ResBookDesigQuantity.toLowerCase() === 'c'
          ) {
            if (!previousIndexList?.includes(index)) {
              previousIndexList.push(index);
              notAvailsFlights.push(item);
            }
          } else {
            if (!previousIndexList.includes(index)) {
              previousIndexList.push(index);
              availsFlights.push(item);
            }
          }
        }),
      ),
    );
  }
  return { availsFlights, notAvailsFlights };
};
export const generateFlightDate = (date) => {
  const _newDate = new Date(date);

  return {
    date: _newDate,
    shamsi: momentjs(
      _newDate.toISOString().split('T')[0],
      DATE_FORMAT_MOMENT_SHAMSI,
    )
      .format(DATE_FORMAT_MOMENT_SHAMSI_JALALI)
      .split('-'),

    miladi: date.split('-'),
    hijri: moment(
      `${
        _newDate.getMonth() + 1
      }/${_newDate.getDate()}/${_newDate.getFullYear()}`,
      'M/D/YYYY',
    )
      .format('iYYYY-iMM-iDD')
      .split('-'),
  };
};
export const jsonToQueryString = (jsonString) => {
  // Parse the JSON string
  const jsonObject = JSON.parse(jsonString);

  // Create an array of key-value pairs
  const pairs = Object.entries(jsonObject);

  // Map each pair to a properly formatted query parameter
  const queryParams = pairs.map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
  );

  // Join all pairs with '&' and prefix with '?'
  const queryString = '?' + queryParams.join('&');

  return queryString;
};
